import { Link } from "react-router";
import Box from "../components/ui/Box";
import { Button } from "../components/ui/button";

const SuccessPaiementPetiteAnnoncePage = () => {
  return (
    <Box className='flex flex-col gap-4'>
      <div className='text-lg font-bold'>Merci pour votre demande de publication !</div>
      <div>
        Le paiement a bien été reçu et votre facture sera disponible d'ici quelques minutes. Votre annonce doit
        maintenant être validée par nos équipes. Vous recevrez un email très bientôt vous confirmant sa publication.
      </div>
      <Link to='/petites-annonces'>
        <Button>Retour à la liste des petites annonces</Button>
      </Link>
    </Box>
  );
};

export default SuccessPaiementPetiteAnnoncePage;
